module.exports = __webpack_public_path__ + "static/images/laptop.e27f7078dbbe5123779e09c16049c706.svg";